<div class="content-card">
  <form [formGroup]="wageParametersStepFormGroup">
    <h2 class="content-card__header">{{ 'WPS-Wage-Parameters' | translate }}</h2>
    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-WorkingTimeGroup' | translate }}</mat-label>
          <mat-select formControlName="workingTimeGroup">
            @for (workingTimeGroup of listOfWorkingTimeGroup$ | async; track workingTimeGroup) {
              <mat-option #matOption [value]="workingTimeGroup.Id">{{
                workingTimeGroup.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-WorkingTimeSystem' | translate }}</mat-label>
          <mat-select formControlName="workingTimeSystem">
            @for (workingTimeSystem of listOfWorkingTimeSystem$ | async; track workingTimeSystem) {
              <mat-option #matOption [value]="workingTimeSystem.Id">{{
                workingTimeSystem.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-AverageHoursPerDay' | translate }}</mat-label>
          <input matInput placeholder="{{ 'WPS-AverageHoursPerDay' | translate }}" formControlName="workingTimeSystemAverageHoursPerDay" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-AverageHoursPerWeek' | translate }}</mat-label>
          <input matInput placeholder="{{ 'WPS-AverageHoursPerWeek' | translate }}" formControlName="workingTimeSystemAverageHoursPerWeek" />
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-PaymentDeadline' | translate }}</mat-label>
          <mat-select formControlName="paymentDeadline">
            @for (paymentDeadline of listOfPaymentDeadlines$ | async; track paymentDeadline) {
              <mat-option #matOption [value]="paymentDeadline.Id">{{
                paymentDeadline.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-WageFrequency' | translate }}</mat-label>
          <mat-select formControlName="wageFrequency">
            @for (wageFrequency of listOfWageFrequency$ | async; track wageFrequency) {
              <mat-option #matOption [value]="wageFrequency.Id">{{
                wageFrequency.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'WPS-WithdrawalMethod' | translate }}</mat-label>
          <mat-select formControlName="withdrawalMethod">
            @for (withdrawalMethod of listOfWagesWithdrawalMethods$ | async; track withdrawalMethod) {
              <mat-option #matOption [value]="withdrawalMethod.Id">{{
                withdrawalMethod.Name | translate
              }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    @if (isTemporaryEmploymentAgreement()) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'WPS-LeaveBasis' | translate }}</mat-label>
            <input matInput type="number" min="1" max="12" placeholder="{{ 'WPS-LeaveBasis' | translate }}" formControlName="leaveBasis" />
          </mat-form-field>
        </div>
      </div>
    }

    @if (isTemporaryEmploymentAgreement()) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'WPS-LeaveRule' | translate }}</mat-label>
            <mat-select formControlName="leaveRule">
              @for (leaveRule of listOfLeaveRules$ | async; track leaveRule) {
                <mat-option #matOption [value]="leaveRule.Id">{{
                  leaveRule.Name | translate
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    }

    @if (isTemporaryEmploymentAgreement()) {
      <div class="row">
        <div class="col">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'WPS-HealthAndSafetyCondition' | translate }}</mat-label>
            <mat-select formControlName="healthAndSafetyCondition">
              @for (healthAndSafetyCondition of listOfHealthAndSafetyConditions$ | async; track healthAndSafetyCondition) {
                <mat-option
                  #matOption
                  [value]="healthAndSafetyCondition.Id"
                  >{{ healthAndSafetyCondition.Name | translate }}</mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (isTemporaryEmploymentAgreement()) {
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'WPS-EmployeeTravelBenefits' | translate }}</mat-label>
              <mat-select formControlName="employeeTravelBenefit">
                @for (employeeTravelBenefit of listOfEmployeeTravelBenefits$ | async; track employeeTravelBenefit) {
                  <mat-option #matOption [value]="employeeTravelBenefit.Id">{{
                    employeeTravelBenefit.Name | translate
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      }

      @if (isTemporaryEmploymentAgreement()) {
        <div class="row">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'WPS-InternalWagesRegulation' | translate }}</mat-label>
              <mat-select formControlName="internalWagesRegulation">
                @for (internalWagesRegulation of listOfInternalWagesRegulations$ | async; track internalWagesRegulation) {
                  <mat-option
                    #matOption
                    [value]="internalWagesRegulation.Id"
                    >{{ internalWagesRegulation.Name | translate }}</mat-option
                    >
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        }

        @if (isTemporaryEmploymentAgreement()) {
          <div class="row">
            <div class="col">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'WPS-WorkQualificationRequrement' | translate }}</mat-label>
                <mat-select formControlName="workQualificationRequrement">
                  @for (workQualificationRequrement of listOfWorkQualificationRequrements$ | async; track workQualificationRequrement) {
                    <mat-option
                      #matOption
                      [value]="workQualificationRequrement.Id"
                      >{{ workQualificationRequrement.Name | translate }}</mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          }

          @if (isTemporaryEmploymentAgreement()) {
            <div class="row">
              <div class="col">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'WPS-TemporaryJobExpectedPeriod' | translate }}</mat-label>
                  <mat-select formControlName="temporaryJobExpectedPeriod">
                    @for (temporaryJobExpectedPeriod of listOfTemporaryJobExpectedPeriods$ | async; track temporaryJobExpectedPeriod) {
                      <mat-option
                        #matOption
                        [value]="temporaryJobExpectedPeriod.Id"
                        >{{ temporaryJobExpectedPeriod.Name | translate }}</mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }

            @if (isTemporaryEmploymentAgreement()) {
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'WPS-HolidayLeaveLimit' | translate }}</mat-label>
                    <mat-select formControlName="holidayLeaveLimit">
                      @for (holidayLeaveLimit of listOfHolidayLeaveLimits$ | async; track holidayLeaveLimit) {
                        <mat-option #matOption [value]="holidayLeaveLimit.Id">{{
                          holidayLeaveLimit.Name | translate
                        }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            }

            @if (isTemporaryEmploymentAgreement()) {
              <div class="row">
                <div class="col">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'WPS-AbsenceConfirmationType' | translate }}</mat-label>
                    <mat-select formControlName="workAbsenceConfirmationType">
                      @for (workAbsenceConfirmationType of listOfWorkAbsenceConfirmationTypes$ | async; track workAbsenceConfirmationType) {
                        <mat-option
                          #matOption
                          [value]="workAbsenceConfirmationType.Id"
                          >{{ workAbsenceConfirmationType.Name | translate }}</mat-option
                          >
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              }

              @if (isTemporaryEmploymentAgreement()) {
                <div class="row">
                  <div class="col">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'WPS-PresenceConfirmationType' | translate }}</mat-label>
                      <mat-select formControlName="workPresenceConfirmationType">
                        @for (workPresenceConfirmationType of listOfWorkPresenceConfirmationTypes$ | async; track workPresenceConfirmationType) {
                          <mat-option
                            #matOption
                            [value]="workPresenceConfirmationType.Id"
                            >{{ workPresenceConfirmationType.Name | translate }}</mat-option
                            >
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                }

                @if (isTemporaryEmploymentAgreement()) {
                  <div class="row">
                    <div class="col">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'WPS-TimeForJustifingAbsence' | translate }}</mat-label>
                        <input
                          matInput
                          type="number"
                          min="1"
                          max="12"
                          placeholder="{{ 'WPS-TimeForJustifingAbsence' | translate }}"
                          formControlName="timeForJustifingAbsence"
                          />
                        </mat-form-field>
                      </div>
                    </div>
                  }

                  <div class="row">
                    <app-multiple-wage-form
                      [wageFormGroup]="wages"
                      [prefetchedAgreement]="prefetchedAgreement"
                      [workingTimeGroup]="selectedWorkingTimeGroup"
                    ></app-multiple-wage-form>
                  </div>

                  <div class="row">
                    <div class="col">
                      <button class="float-left" mat-raised-button color="primary" (click)="submit()" matStepperPrevious>{{ 'Back' | translate }}</button>
                      <button class="float-right" mat-raised-button color="primary" (click)="submit()" matStepperNext>{{ 'Next' | translate }}</button>
                    </div>
                  </div>
                </form>
              </div>
